import { jsx as _jsx } from "react/jsx-runtime";
import BrandQnA from "@/components/Brand/QnA";
import { withBrandLayout } from "@/modules/lab/components/BrandLayout";
// 공지 글쓰기 화면은 저자만 작성할 수 있다.
const BrandQnAPage = (param)=>{
    let { author , labDataResult  } = param;
    return /*#__PURE__*/ _jsx(BrandQnA, {});
};
export var __N_SSP = true;
export default withBrandLayout(BrandQnAPage);
